import React from "react";
import { Button, Col, Form, Row, Input } from "antd";
import {
  GUTTER_MD,
  MARGIN_MD,
  SPAN_FULL,
  MARGIN_SM,
  MODAL_WIDTH_SM,
} from "../../../../../styles/constants";
import EnhancedModal from "../../../../../components/enhanced-modal";
import { compose } from "redux";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  changeFileMappingWizardCalcExport,
  submitFileMappingWizardExportCalcRules,
  onHideExportCalcRules,
} from "./actions";

const mapStateToProps = (state) => ({
  exportRulesForm: state.scenes.dataManager.fileMapping.components.wizard.shared.exportRulesForm,
  isVisible: state.scenes.dataManager.fileMapping.components.wizard.shared.exportCalcRulesShow,
  mergedHeader: state.scenes.dataManager.fileMapping.components.wizard.shared.mergedHeader,
  tempTableName: state.scenes.dataManager.fileMapping.components.wizard.shared.tempTableName,
});

const mapDispatchToProps = (dispatch) => ({
  onChange: (fields) => dispatch(changeFileMappingWizardCalcExport(fields)),
  onSubmit: (name, tableName, mergedHeader) =>
    dispatch(submitFileMappingWizardExportCalcRules(name, tableName, mergedHeader)),
  onHide: () => dispatch(onHideExportCalcRules()),
});

const mapPropsToFields = ({ exportRulesForm }) => ({
  name: Form.createFormField({ value: exportRulesForm ? exportRulesForm.name : null }),
});

const onFieldsChange = (props, fields) => props.onChange(fields);

const FileMappingWizardRulesExportForm = ({
  t,
  form,
  isVisible,
  exportRulesForm,
  onSubmit,
  onHide,
  tempTableName,
  mergedHeader,
}) => {
  return (
    <EnhancedModal
      visible={isVisible}
      onCancel={() => onHide()}
      title={t('scenes.dataManager.fileMapping.wizard.downloadExport.title')}
      width={MODAL_WIDTH_SM}
      footer={
        <div>
            <Button onClick={() => onHide()}>
              {t("commons.buttons.close.title")}
            </Button>
            <Button
              disabled={exportRulesForm ? (exportRulesForm.name === null || exportRulesForm.name === '') : true}
              icon="download"
              type="primary"
              onClick={() => onSubmit(exportRulesForm.name, tempTableName, mergedHeader)}
            >
              {t('scenes.dataManager.fileMapping.wizard.downloadExport.label')}
            </Button>
        </div>
      }
    >
      <Form className="advanced-form">
        <Row type="flex" style={{ marginBottom: MARGIN_MD }} gutter={GUTTER_MD}>
          <Col span={SPAN_FULL}>
            <Form.Item
              className="form-item-required"
              label={t('scenes.dataManager.fileMapping.wizard.downloadExport.inputName')}
              style={{ marginRight: MARGIN_SM }}
            >
              {form.getFieldDecorator("name")(
                <Input
                  onKeyPress={(event) => {
                    if (!/^[\w,\s,\(\)-]+$/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  title={form.getFieldValue("name")}
                />)
              }
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </EnhancedModal>
  );
};

export default compose(
  translate(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  Form.create({ mapPropsToFields, onFieldsChange })
)(FileMappingWizardRulesExportForm);
